/* global axios */
import { msBaseUrl } from './microservicos';

export const attendanceTypesAPI = {
  getAll(accountId, activeOnly = false) {
    return axios.get(`${msBaseUrl('crm', accountId)}/attendance-types`, {
      params: { activeOnly },
    });
  },

  create(accountId, data) {
    return axios.post(`${msBaseUrl('crm', accountId)}/attendance-types`, data);
  },

  update(accountId, id, data) {
    return axios.put(
      `${msBaseUrl('crm', accountId)}/attendance-types/${id}`,
      data
    );
  },

  delete(accountId, id) {
    return axios.delete(
      `${msBaseUrl('crm', accountId)}/attendance-types/${id}`
    );
  },
};
